var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.234 27.909V4.09a.4.4 0 01.652-.31L24.53 15.69a.4.4 0 010 .62L9.886 28.22a.4.4 0 01-.652-.311z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik05LjIzMzg5IDI3LjkwODhWNC4wOTA5MkM5LjIzMzg5IDMuNzU0MDEgOS42MjQ5IDMuNTY4MDIgOS44ODYyOCAzLjc4MDZMMjQuNTI4OCAxNS42ODk1QzI0LjcyNTYgMTUuODQ5NiAyNC43MjU2IDE2LjE1MDEgMjQuNTI4OCAxNi4zMTAyTDkuODg2MjggMjguMjE5MUM5LjYyNDkgMjguNDMxNyA5LjIzMzg5IDI4LjI0NTcgOS4yMzM4OSAyNy45MDg4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { Svg32 as ReactComponent };